module.exports = __webpack_public_path__ + "static/media/circle-cloud-3.d5a558ee.png";